var e={props:{id:{type:String,required:!0},background:{type:Boolean,default:!1}}};export default e;
